import React from "react";
import { Spinner } from "react-bootstrap";

const MainSpinner = ({ className }) => {
  return (
    <div className={`spinner-backdrop ${className}`}>
      <Spinner animation="border" role="status" variant="primary">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  );
};

export default MainSpinner;
